import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, Grid } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import useCheckMobile from "src/hook/useCheckMobile";

interface Props {
    data: any[];
    onClick?: (value: any) => void;
    onDeleteItem?: (value: number | null) => void;
}

const CardToken = (props: Props) => {
    const isMobile = useCheckMobile()
    const {
        data,
        onClick,
        onDeleteItem,
    } = props;

    const deleteTokenCard = (item: any) => {
        onDeleteItem(item?.id);

    }

    return (
        <>
            <Grid container spacing={2}>
                {
                    data && data.map((item, index) => {
                        return <Grid item xs={12} md={4} key={index} >

                            <Box sx={{
                                backgroundColor: "rgba(245, 245, 245, 0.7)",
                                borderRadius: "5px",
                                padding: "10px",
                                cursor: "pointer"

                            }}

                            >
                                <Grid container spacing={1}>
                                    <Grid item xs={2.5} >
                                        <Box sx={{
                                            display: "flex",
                                            height: "100%",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                            onClick={() => onClick(item)}
                                        >
                                            {
                                                !item?.cardType &&  <img src="/icons/card-icon.png" />
                                            }
                                            {
                                                item?.cardType === "ATM" &&  <img src="/icons/card-icon.png" />
                                            }
                                            {
                                              item?.cardType &&  item?.cardType !== "ATM" &&  <img src="/icons/card-visa-icon.png" />
                                            }
                                        </Box>
                                    </Grid>
                                    <Grid item xs={8} >
                                        <Box onClick={() => onClick(item)}>
                                            <div style={{ color: "#0B2C4A", fontSize: "16px" }}>{item.cardType} {item.cardType && item.bankCode && <>-</>} {item.bankCode}</div>
                                            <div style={{ color: "#5C7286", fontSize: "14px" }}>{item.cardNumber}</div>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={1.5} >
                                        <Box sx={{
                                            display: "flex",
                                            height: "100%",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "#DD0071"
                                        }}>
                                            <IconButton onClick={() => deleteTokenCard(item)} aria-label="delete">
                                                <img src="/icons/Delete.png" />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    })
                }
            </Grid>
        </>
    );
};

export default CardToken;
